// What the courier collects at the door — the admin card's copy of the one rule.
//
// ⚠️ 2026-09-29, money bug 3. The AMEEX card defaulted « Acompte déjà reçu »
// to app_settings.advance_amount × albums (50 per album), ticked, for EVERY
// order, and sent that figure to the worker as `advance_override` — so a
// cash-on-delivery client who paid nothing had 50 MAD per album left
// uncollected at her door, and a client whose 150 MAD receipt was accepted was
// billed as if she had paid 50. The rule, from the owner: total − what was
// actually received; 0 when paid in full; the full total when nothing was.
//
// MIRRORS worker/src/lib/orderMoney.ts `amountReceived` / `cashToCollect`
// exactly; worker/src/lib/cashToCollect.parity.test.ts holds the two together
// number for number. Change one, change both.

/** The order's money columns (see worker/src/lib/orderMoney.ts). */
export interface OrderMoney {
  payment_method?: string | null;
  paid_at?: string | null;
  paid_in_full?: boolean | null;
  advance_received_amount?: number | string | null;
  advance_received_at?: string | null;
  advance_amount?: number | string | null;
  status?: string | null;
}

/**
 * What the client has actually paid us, in MAD — 0 when nothing is recorded.
 * The RECEIVED column (an accepted receipt, « Acompte reçu ») wins over the
 * card's own acompte field, even at 0.
 */
export function amountReceived(o: OrderMoney | null | undefined): number {
  if (!o) return 0;
  const recorded = o.advance_received_amount ?? o.advance_amount;
  if (recorded == null || recorded === '') return 0;
  const n = Number(recorded);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** Total − what was actually received; 0 when paid in full; never negative. */
export function cashToCollect(o: { total: number | string | null | undefined } & OrderMoney): number {
  const total = Number(o.total);
  if (!Number.isFinite(total) || total <= 0) return 0;
  if (o.paid_in_full === true) return 0;
  const owed = total - amountReceived(o);
  return owed > 0 ? Math.round(owed * 100) / 100 : 0;
}
